import React, { Component, useState, useEffect, useRef } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';

import $ from 'jquery';
import Cookies from 'js-cookie';
import Col from 'react-bootstrap/Col';

export const user_session_id = 'user';
export const shopping_cart_session_id = 'shoppingcart';
export const days = 8 / 24;
export const shopping_cart_session_days = days;

export const BackToKdealerLogin = () => {
    if (window.location.origin.indexOf("dev-kdealer") > -1 || window.location.origin.indexOf("sb-kdealer") > -1) {
        window.location.href = 'https://www.dev1-k-dealer.com';
    }
    else {
        window.location.href = 'https://www.k-dealer.com/';
    }
}
export const GetDomain = () => {
    console.log(window.location.origin);
    if (window.location.origin.indexOf("localhost") > -1) {
        return "";
    }
    else {
        return window.location.origin.replace('https://','');
    }
}
export const CheckSession = () => {
    const ck = GetCoockie();
    //console.log(ck);
    if (!ck) {
        window.location.href = '/login';
    }
}
export const FormatCurrency = (number) =>{
    return number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
}
export const GetCoockie = () => {
    //let domain = GetDomain();
    let usr = Cookies.get(user_session_id);
    try {
        if (usr) {
            const jsonObject = JSON.parse(usr);
            return jsonObject;
        }
    }
    catch (e) {
        console.log(e);
    }
    
    return null;
    
}

export const ValidateQty = (val) => {
    try {
        if (val.length === 0) {
            throw new Error("empty.");
        }
        if (/^-?\d+$/.test(val) === false) {
            throw new Error("Only integer is allowed.");
        }
        const num = Number(val);
        if (num > 999 || num < 1) {
            debugger;
            if (num > 999 && val.trim().length > 3) {
                return val.substring(0,3);
            }
            else {
                throw new Error("Out of range.");
            }
           
        }
        else {
            return val;
        }
    }
    catch (e) {
        console.log(e);
        return '';
    }

}
export const RemoveCookie = (days,sessionId) => {
    let domain = GetDomain();
    if (domain === '') {
        Cookies.remove(sessionId, { expires: days });
    }
    else {
        Cookies.remove(sessionId, { expires: days, domain: domain });
    }

}

export const DefaultImage = "../../../Images/404.png";

export const GetShoppingCart = (shoppingCartFromContext) => {
    //const sc = localStorage.getItem(shopping_cart_session_id);
    //return sc ? JSON.parse(sc) : null;
    return shoppingCartFromContext || null;
}

export const UpdateShoppingCart = (obj, setShoppingCart) => {
    setShoppingCart(obj);
    localStorage.setItem(shopping_cart_session_id, JSON.stringify(obj));
}
export const KImageURL = (sku, fileName) => {
    if (!sku || !fileName) {
        return "";
    }
    const newSKU = sku.replaceAll('-', '');
    return `https://www.kawasaki.com/content/uploads/accessories/${newSKU}/${fileName}`;
}
export const SearchContent = (key) => {
    const isSESOrder = IsSESOrderID(key);
    const isInvoiceID = IsInvoiceID(key);
    const isKMCOrderID = IsKMCOrderID(key);
    let str = '';
    if (isSESOrder) {
        str = 'Ref: #';
    }
    else if (isInvoiceID) {
        str = 'INVOICE: #';
    }
    else if (isKMCOrderID) {
        str = 'Order: #';
    }
    else {
        str = 'Item: #';
    }
    str += key;
    return (
        <Col sm={12} key={"col1_" + key}>
            <h5 className="heading green-text text-left mt-2">{str}</h5>
        </Col>
    );
}
const IsSESOrderID = (val) => {
    return val.startsWith('KDL') || val.startsWith('KCN');
}
const IsInvoiceID = (val) => {
    return val.startsWith('P00');
}
const IsKMCOrderID = (val) => {
    return val.startsWith('0000');
}
export const  PrintDocument = async (crNum) => {
    CheckSession();
    const session = GetCoockie();
    const data = {
        label: session.dealerID,
        value: crNum
    }
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    const response = await fetch("kdealer/CreditRequestPrintDocument/", requestOptions);
    if (response.status !== 200) {
        return;
    }
    const res = await response.text();
    //setCRDocument(res);
    window.open(res, '_blank');
    console.log(res);
}
export const GetSKUDetailGlb = async (skuqty, orderType, orderName, shiptoDealerID) => {
   

    try {
        let errorMsg = '';
        CheckSession();
        const user = GetCoockie();
        //handlePop();
        const data = {
            valueLabels: skuqty,
            orderType: orderType,
            dealerID: user.dealerID,
            userKey: user.userKey
        };
        const rqst = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const res = await fetch('kdealer/GetSkuInfo/', rqst);
        if (res.status !== 200) {
            throw new Error("API error occurred");
        }
        const js = await res.json();
        const addInfo = new Map();
       
        const arrSubs = [];
        let errorSet = new Set();
        let alertFactor = 0, boCount = 0;
        let LTL = false;
        let pk = false;
        const newSkuQty = [];
        console.log(js);
        js.map((item) => {
            if (item.distitemNbr !== "") {
                if (item.errorMsg !== "") {
                    if (item.errorMsg.toLowerCase().indexOf("invalid") > -1) {
                        errorSet.add("At least one Item Number is invalid.");
                    } else {
                        errorSet.add(item.errorMsg);
                    }
                    errorMsg += item.errorMsg;
                }
                else {
                    newSkuQty.push({
                        sku: item.distitemNbr,
                        qty: item.qtyOrdered
                    }
                    );
                    if (item.substitutedSKU !== "") {
                        arrSubs.push(`${item.substitutedSKU} is substituted by ${item.distitemNbr}`);
                    }
                    if (item.factorAlert) {
                        alertFactor++;
                    }
                    if (item.boCnt > 0) {
                        boCount++;
                    }
                    if (item.ltl === true) {
                        LTL = true;
                    }
                    if (item.pk === true) {
                        pk = true;
                    }
                    if (item.itemStaCode === "4") {
                        item.qty = 0;
                    }
                }
                
            }
            
            return '';
        });
        if (errorMsg !== '' && skuqty.length === 1) {
            throw new Error(errorMsg);
        }
        if (newSkuQty.length === 0) {
            throw new Error("Error");
        }
        //Item Number
        const skuqty2 = {
            valueLabels: newSkuQty,
            orderType: "1",
            dealerID: user.dealerID,
            userKey: user.userKey
        };
        const rqst2 = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(skuqty2)
        };
        const res2 = await fetch('kdealer/GetSkuInfo2/', rqst2);
        if (res2.status !== 200) {
            throw new Error(res.statusText);
        }
        const js2 = await res2.json();

        js2.map((item) => {
            if (item.itemStaCode === "1" || item.itemStaCode === "2") {
                addInfo.set(item.itemNumber.replaceAll('-', ''), item);
            }
            return '';
        });


        let skuObjs = [];
        js.map((item) => {
            if (item.distitemNbr !== "" && (item.itemStaCode === "1" || item.itemStaCode === "2")) {
                const info = {
                    item: item,
                    addInfo: addInfo.get(item.distitemNbr.replaceAll('-', ''))
                }
                skuObjs.push(info);
            }
            return '';
        });

        const alerts = [
            alertFactor > 0 && { type: 'packQuantity' },
            boCount > 0 && { type: 'backorder' },
            LTL && { type: 'ltlShipping' },
            pk && { type: 'packageBuilt' },
            arrSubs.length > 0 && { type: 'substitutions' }
        ].filter(Boolean);
        
        const newCart = {
            alerts: alerts,
            items: skuObjs,
            orderName: orderName,
            shipToDealerID: shiptoDealerID,
            orderType: orderType,
            kCode: ''
        }
        const obj = {
            cart: newCart,
            error: ''
        }
        return obj;
    } catch (error) {
        console.log(error);
        //return { success: false, error: 'API error occurred' };
        const res = {
            cart: null,
            error: error.message
        }
        return res;
    } 
}
export const IsKDealerWebsite = () => {
    return window.location.hostname.indexOf('-kdealer') > -1 || window.location.hostname.indexOf('k-dealer') > -1;
}
export const IskCountryWebsite = () => {
    return window.location.hostname.indexOf('-kcountries') > -1 || window.location.hostname.indexOf('k-countries') > -1;
}
export const IsLocalHost = () => {
    return window.location.hostname.indexOf('localhost') > -1 || window.location.hostname.indexOf('localhost') > -1;
}
export const GetRedirectHost = () => {
    console.log(window.location.hostname);
    //return "https://sb-kcountries.ses-bms.com";
    if (window.location.hostname.indexOf('sb-kdealer') > -1) {
        return "https://sb-kcountries.ses-bms.com";
    }
    else if (window.location.hostname.indexOf('shop.k-dealer') > -1) {
        return "https://shop.k-countries.com";
    }
    else if (window.location.hostname.indexOf('sb-kcountries') > -1) {
        return "https://sb-kdealer.ses-bms.com";
    }
    else if (window.location.hostname.indexOf('shop.k-countries') > -1) {
        return "https://shop.k-dealer.com";
    }
    else {
        return "";
    }
}
export const formatDateMMDDYYYY = (dateObj) => {
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${month}/${day}/${year}`;
};
export const IsTestDealer = (dealerID) => {
    return dealerID && dealerID === "0106";
};
export const generateSixDigitNumber = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
}
